export class RecommendationMapping {
	Id: number;
	RecommendationId: number;
	RecommendedId: number;
	RecommendationTypeId: number;
}
